export default {
  harassment: {
    create: {
      ingress:
        'Här har du möjlighet att berätta mer om vad du har bevittnat eller upplevt på {organizationTitle}. Vi är mycket tacksamma för din hjälp att få en säker arbetsplats.',
      instructions:
        'Skriv din rapport i textfältet här nedanför. Du kan välja att inkludera din epost-adress eller vara anonym. I vilket fall är det möjligt att komma tillbaka och följa upp ditt ärende efter att du skickat in rapporten.',
      instructions1:
        'Du kommer få en bekräftelse på att rapporten är skickad, ett ärende-id och ett lösenord som du kan använda, oavsett om du är anonym eller inte, för att komma tillbaka senare och följa upp på ärendet.',
      instructions2:
        'Rapporter tas emot av utsedda administratörer på {organizationTitle}. Ingen annan kan läsa rapporten du skickar. Om du anger en epost-adress kommer du bli notifierad när ärendet ändrar status och om det finns frågor från organisationen till dig. Vi kommer då hantera din identitet konfidentiellt och inte avslöja det om det inte är nödvändigt för ärendet.',
      instructionsHeader: 'Hur fungerar det?',
      options: {
        confirmNotToIncludeEmail:
          'Jag förstår att genom att inte ange min epost-adress avsäger jag mig möjligheten att bli notifierad när status på mitt ärende ändras och att mottagande organisation inte vet vem jag är.',
        includeEmail: 'Jag vill inkludera min epost-adress'
      }
    },
    reportingChannels: {
      digitalReport: {
        confirmDescription:
          'Efter du skickat rapporten kommer du inte längre kunna läsa eller göra ändringar av säkerhetsskäl. Du kan däremot komma tillbaka senare och följa status för ärendet, se uppföljningsfrågor från {organizationTitke} och själv, anonymt, komplettera med mer information.',
        confirmDescriptionEmailIncluded:
          'Eftersom du valt att inkludera din epost-adress kommer vi kontakta {email} när ärendet öppnas och om vi har några frågor åt dig. Kontrollera din rapport nedan innan du skickar in den.',
        confirmDescriptionEmailNotIncluded:
          'Du har valt att inte inkludera en epost-adress så vi kommer inte kunna ta kontakt med dig. Kontrollera rapporten nedan innan du skickar in den.',
        createDescription: 'Skriv vad som hänt här:',
        placeholder: 'Jag skulle vilja rapportera att...',
        reporterGuide: {
          question1: 'Vad handlar det om?',
          question2: 'När hände detta?',
          question3: 'Vilka var inblandade?',
          question4: 'Var hände det?',
          question5: 'Har du med alla detaljer?',
          question6: 'Du kan ha med en bild om du vill',
          title: 'Guide för att skriva en bra rapport'
        },
        responseDescriptionEmailIncluded:
          'Du kommer få en epost-notifikation när ärendet öppnas av en administratör.'
      }
    },
    title: 'Rapportera till {organizationTitle}'
  },
  whistleblower: {
    alerts: {
      notValidLink:
        'Vänligen följ en korrekt länk för att komma till den här sidan.'
    },
    buttons: {
      back: 'Gå tillbaka',
      continue: 'Fortsätt',
      noOption: 'Nej',
      send: 'Skicka rapport',
      yesOption: 'Ja'
    },
    confirm: {
      title: {
        reportNotSent: 'Rapport INTE skickad!'
      }
    },
    create: {
      email: {
        help:
          'Om du väljer att inkludera en e-postadress med din rapport så kommer vi återkomma med statusuppdatering eller om vi har några frågor. Att lägga till en epost-adress är frivilligt.',
        label: 'Epost:',
        placeholder: 'Fyll i din e-postadress här'
      },
      ingress:
        'Här kan du rapportera såväl kännedom som misstanke om missförhållanden som uppstått eller högst sannolikt kommer att uppstå i verksamheten på {organizationTitle}. Kanalen ska endast användas för missförhållanden i arbetsrelaterade sammanhang och endast om du har skälig anledning att anta att informationen om missförhållandena är sann.',
      instructions:
        'Välj först hur du vill lämna din rapport: i det här formuläret, i ett fysiskt möte eller via ett telefonsamtal. Du kan också bestämma huruvida du vill inkludera din e-postadress eller vara anonym. Om du väljer att rapportera här får du i nästa steg möjlighet att granska din rapport innan du väljer att skicka iväg den. ',
      instructions1:
        'Därefter kommer du få bekräftelse på att rapporten har skickats samt ett ärende-id och lösenord som du kan använda, oavsett om du är anonym eller inte, för att senare komma tillbaka och följa upp ärendet. Även om du väljer att rapportera via fysiskt möte eller telefonsamtal kommer du ändå senare kunna följa upp ärendet digitalt om du så önskar.',
      instructions2:
        'Rapporter tas emot av utsedda administratörer på {organizationTitle}. Om du angett din e-postadress kommer du bli meddelad när ärendet ändrar status samt om det inkommer en fråga från företaget. Vi hanterar då din identitet konfidentiellt och kommer inte röja den om det inte är nödvändigt för ärendet.',
      instructionsHeader: 'Hur fungerar det?',
      options: {
        confirmNotToIncludeEmail:
          'Jag förstår att jag genom att inte ange e-postadress avstår bekräftelse på mottagande av rapporten per e-post samt möjligheten att bli meddelad när status på mitt ärende ändras samt att mottagande organisation inte vet vem jag är.',
        includeEmail: 'Jag vill inkludera en e-postadress'
      }
    },
    followup: {
      buttons: {
        submit: 'Hämta ärende'
      },
      messages: {
        buttons: {
          send: {
            help:
              'Du kan skicka ett uppföljande meddelande som organisationen kommer läsa. Ingen annan kan läsa ditt meddelande.',
            title: 'Skicka meddelande'
          }
        },
        messageSent: 'Tack för ditt meddelande!',
        placeholder: 'Skriv ditt meddelande här',
        reporter: 'Rapportör',
        title: 'Meddelanden',
        writtenByAdmin: 'Admin'
      },
      status: {
        new: {
          description:
            'Din rapport har mottagits och kommer granskas inom kort.',
          title: 'Nytt'
        },
        open: {
          description:
            'Din rapport har tagits emot och håller på att granskas. Kom tillbaka senare för uppdateringar. Om du har angett din e-postadress kommer vi kontakta dig om vi har frågor.',
          title: 'Öppet'
        },
        solved: {
          description:
            'Din rapport har hanterats och undersökningen är nu avslutad. Om du har meddelat oss kontaktinformation kommer vi återkomma till dig med detaljer.',
          title: 'Avslutat'
        }
      },
      statusLabel: 'Ärendet har status:',
      title: 'Ärende {caseName}'
    },
    followupLogin: {
      caseLabel: 'Ärende-id:',
      passwordLabel: 'Lösenord:',
      title: 'Uppföljning av ärende'
    },
    messages: {
      error: {
        failedToSendReport: 'Kunde inte skicka rapporten',
        organizationNotFound:
          'Vi kunde inte hitta en organisation som kan ta emot din rapport. Kontrollera att du följt en korrekt länk för att komma hit.',
        whistleblowerInfoNotFound:
          'Kunde inte hitta information om visselblåsar-konfiguration för organisationen'
      }
    },
    received: {
      bottomWarning:
        'Notera! Det här är enda möjligheten då du kan se informationen ovan, så spara undan den nu!',
      caseLabel: 'Ärende-id:',
      linkLabel: 'Länk',
      passwordLabel: 'Lösenord:',
      thankyouTitle: 'Tack',
      title: 'Rapport mottagen!',
      topWarning: 'Spara undan nedanstående information säkert!'
    },
    reportingChannels: {
      digitalReport: {
        confirmDescription:
          'Efter du skickat rapporten kommer du av säkerhetsskäl inte längre kunna läsa eller göra ändringar. Däremot kan du komma tillbaka senare och följa status för ärendet, se eventuella uppföljningsfrågor från organisationen eller själv lägga till mer information.',
        confirmDescriptionEmailIncluded:
          'Eftersom du valt att inkludera din e-postadress kommer vi kontakta dig på {email} när ärendet öppnas eller om vi har några frågor till dig. Kontrollera innehållet i din rapport nedan innan du skickar in den.',
        confirmDescriptionEmailNotIncluded:
          'Du har valt att inte inkludera en e-postadress med din rapport så vi kommer inte kunna kontakta dig. Kontrollera att din rapport är korrekt innan du skickar in den.',
        createDescription:
          'Beskriv vad som har hänt och varför du vill rapportera det här. Inkludera inte personlig information om det inte är relevant för ärendet.',
        label: 'Jag vill rapportera digitalt via det här formuläret',
        placeholder: 'Jag skulle vilja rapportera att...',
        reporterGuide: {
          question1: 'Vad vill du rapportera?',
          question2: 'När hände detta?',
          question3: 'Vilka var inblandade?',
          question4: 'Var hände det?',
          question5: 'Har du inkluderat alla detaljer?',
          question6: 'Du kan lägga till en bild om du vill',
          title: 'Guide till att skriva rapporten'
        },
        responseDescriptionEmailIncluded:
          'Eftersom du angav din e-postadress kommer vi kontakta dig via e-post till  {email} när ärendet öppnats av en administratör, som bekräftelse på att rapporten har mottagits. Detta kommer ske inom 7 dagar. Efter ärendet öppnats kommer vi att inom 3 månader återkoppla till dig om åtgärder som vidtagits vid uppföljning av rapporten.',
        responseDescriptionEmailNotIncluded:
          'Eftersom du har valt att rapportera anonymt har du avsagt dig att få en notifiering med bekräftelse på att rapporten är mottagen. Du kommer inte heller att få en notifiering kring aktivitet i ärendet. Genom inloggningsuppgifterna nedan har du däremot möjlighet att själv hämta uppgift om när bekräftelse på att rapporten är mottagen har lämnats och följa ärendets status på ärendesidan. Du kommer t.ex. kunna se information om eventuella åtgärder som har vidtagits vid uppföljning av rapporten.',
        responseIngress:
          'Tack för din rapport! Vi kommer hantera ditt ärende så snart som möjligt.'
      },
      phoneCall: {
        confirmDescription:
          'Vid nästa steg kommer du få se ett telefonnummer som du kan ringa. Är du säker på att du vill fortsätta rapportera via telefonsamtal?',
        createDescription:
          'Du kommer få möjlighet att tala in din rapport som ett röstmeddelande.',
        label: 'Jag vill lämna rapport via ett telefonsamtal',
        message:
          '=== Rapportören kommer ringa och lämna rapport som röstmeddelande ===',
        responseDescription:
          'För att lämna din rapport behöver du ringa upp följande telefonnummer och tala in ett röstmeddelande:',
        responseInstructions1: 'Ring telefonnumret här ovan',
        responseInstructions2: 'Lämna en så detaljerad rapport som möjligt',
        responseInstructions3:
          'Om du vill bli meddelad om statusändringar eller ny korrespondens kan du nämna din e-postadress eller telefonnummer när du talar in din rapport.',
        responseInstructions4:
          'Spara nedanstående information så du senare kan komma tillbaka och följa upp ditt ärende',
        responseInstructionsHeader: 'Instruktioner',
        responseTitle: 'Rapportera via telefon',
        responseWarning:
          'Om du inte har lämnat ett röstmeddelande inom 7 dagar kommer ditt ärende automatiskt stängas.'
      },
      physicalMeeting: {
        confirmDescription:
          'Vi kommer kontakta dig via e-post på {email} för att boka tid till ett fysiskt möte. Vill du fortsätta?',
        createDescription:
          'Vi erbjuder möjligheten att lämna din rapport i ett fysiskt möte. För att göra detta behöver du ange en e-postadress som vi kommer använda för att kontakta dig för att bestämma tidpunkt för mötet.',
        label: 'Jag vill rapportera i ett fysiskt möte',
        message:
          '=== Rapportör önskar ett fysiskt möte för att förmedla rapporten ===',
        responseDescription:
          'Tack! Vi återkommer inom kort med ett förslag på tid då vi kan ha ett fysiskt möte där du kan lämna din rapport. Spara undan följande information. Du kommer behöver det efter mötet för att kunna följa upp på ärendet.',
        responseTitle: 'Mötesförfrågan skickad'
      }
    },
    title: 'Rapportera missförhållande hos {organizationTitle}'
  }
}
